import React, { useEffect, useState } from "react"
import { motion } from 'framer-motion'
import Filters from "./Filters"
import ProfileList from "./ProfileList"
import PlanDetails from "./PlanDetails"
import FilteredProfile from "./FilteredProfile"
import AccountDetails from "./AccountDetails"
import { useDispatch, useSelector } from "react-redux"
import API from "../../Common/API"
import { setMaxAge, setMinAge, setUserDetails } from "../../Store/Auth/actions"
import { useTranslation } from "react-i18next"
const HomePage = () => {

    const dispatch = useDispatch()
    const userDetails = useSelector((state)=>state.auth.userDetails)
    const fetchUserDetails = useSelector((state)=>state.auth.fetchUserDetails)
    const mobileFilters = useSelector((state)=>state.auth.mobileFilter)
    const [showMobilePlans, setShowMobilePlans] = useState(false);
    const {t} = useTranslation()
    
    
    useEffect(()=>{
        if(fetchUserDetails !== 0 && userDetails){
             API.get(`/user/getUserDetailsById/${userDetails.id}`).then((res) => {
                localStorage.setItem("userDetails", JSON.stringify(res.data.data));
                dispatch(setMinAge(res.data.data.prefMinAge))
                dispatch(setMaxAge(res.data.data.prefMaxAge))
                dispatch(setUserDetails(res.data.data));
            })
        }
    },[fetchUserDetails])

    return (
        // <>
        //     <motion.div className="flex md:block hidden flex-col bg-gray-200 overflow-auto rounded-md w-full min-h-screen px-10 py-10 items-center">
        //         <motion.div className="w-full h-full flex flex-row gap-5">
        //             <motion.div className="w-1/5 h-full overflow-scroll rounded-lg bg-white">
        //                 <Filters />
        //             </motion.div>
        //             <motion.div className="flex flex-col w-3/5 gap-2">
        //                 <motion.div className="h-full rounded-lg">
        //                     <ProfileList />
        //                 </motion.div>
        //             </motion.div>
        //             <motion.div className="w-1/5 gap-5 flex flex-col h-full">
        //                 <PlanDetails />
        //                 <FilteredProfile />
        //             </motion.div>
        //         </motion.div>
        //     </motion.div>
        //     <motion.div className="md:hidden block">
        //         <motion.div className="h-full w-full rounded-lg">
        //             <ProfileList />
        //         </motion.div>
        //     </motion.div>
        // </>
        <>
            {/* Desktop View */}
            <motion.div className="hidden md:flex flex-col bg-gray-200 overflow-auto rounded-md w-full min-h-screen px-10 py-5 items-center">
                <motion.div className="w-full h-full flex flex-row gap-5">
                    {/* Filters */}
                    <motion.div className="w-1/5 h-full overflow-auto rounded-lg bg-white">
                        <Filters />
                    </motion.div>

                    {/* Profiles */}
                    <motion.div className="flex flex-col w-3/5 gap-2">
                        <motion.div className="h-full rounded-lg">
                            {userDetails.status !== 6 ? <ProfileList /> : <p className="flex felx-col justify-center items-center h-full font-bold">{t('Your changes are under verification.You can start searching once you are verified.')}</p>}
                        </motion.div>
                    </motion.div>

                    {/* Plan & Filtered Profiles */}
                    <motion.div className="w-1/5 gap-5 flex flex-col h-full">
                    <AccountDetails/>
                        <PlanDetails />
                        <FilteredProfile />
                    </motion.div>
                </motion.div>
            </motion.div>

            {/* Mobile View */}
            <motion.div className="md:hidden block py-4">
                {/* Filter Toggle Button */}
                {/* <div className="w-full flex flex-row items-center justify-between  mb-3">
                    <button
                        className="bg-primeColor text-white px-4 py-2 rounded-lg font-bold"
                        onClick={() => setShowMobilePlans(!showMobilePlans)}
                    >
                        {showMobilePlans ? 'Close Plan Details' : 'Open Plan Details'}
                    </button>
                    <button
                        className="bg-primeColor text-white px-4 py-2 rounded-lg font-bold"
                        onClick={() => setShowMobileFilters(!showMobileFilters)}
                    >
                        {showMobileFilters ? 'Apply Filters' : 'Show Filters'}
                    </button>
                </div> */}

                {/* Filters Section - toggled */}
                {mobileFilters && (
                    <div className="mb-4 p-3  rounded-lg bg-white shadow-md">
                        <Filters />
                    </div>
                )}

                {showMobilePlans && <div className="mb-4 p-3  rounded-lg bg-white shadow-md">
                    <PlanDetails />
                    <FilteredProfile />
                </div>}

                {/* Profile List */}
                <motion.div className="h-full w-full rounded-lg">
                    <ProfileList />
                </motion.div>
            </motion.div>
        </>
    )
}

export default HomePage